/**
 * OwSuite — Tenant Konfigürasyonu
 * VUE_APP_TENANT env değişkeni ile aktif tenant seçilir.
 * Tanımsızsa default: 'main'
 */

export const tenantConfig = {
  main: {
    name: 'OwSuite',
    logo: '/tenants/main/logo.png',
    favicon: '/favicon.ico',
    primaryColor: '#1976d2',
    appTitle: 'OwSuite',
    features: {
      fleet_optimization: true,
      frequency_optimization: true,
      task_assignment: true,
      gtfs: true,
      route_optimization: true,
      competition_analysis: true,
      static_map: false,
      filo_postgres_analiz: false,
    },
  },
  burulas: {
    name: 'Burulaş',
    logo: '/tenants/burulas/logo.png',
    favicon: '/tenants/burulas/favicon.ico',
    primaryColor: '#ff5722',
    appTitle: 'Burulaş Planlama',
    features: {
      fleet_optimization: true,
      frequency_optimization: true,
      task_assignment: true,
      gtfs: true,
      route_optimization: true,
      competition_analysis: true,
      static_map: true,
      filo_postgres_analiz: true,
    },
  },
}

/** Aktif tenant ID */
export const CURRENT_TENANT_ID = process.env.VUE_APP_TENANT || 'main'

/** Aktif tenant config objesi */
export const currentTenant = tenantConfig[CURRENT_TENANT_ID] || tenantConfig.main

/**
 * Bir feature'ın aktif tenant için açık olup olmadığını kontrol eder.
 * @param {string} feature
 * @returns {boolean}
 */
export function isFeatureEnabled(feature) {
  return Boolean(currentTenant.features?.[feature])
}
